/* eslint-disable class-methods-use-this */
import axios from 'axios';
import Fingerprint2 from 'fingerprintjs2';

const NO_DATA = 'NO_DATA';

const getFileFormData = (file) => {
  const formData = new FormData();

  formData.append('file', file, file.name);

  return formData;
};

export default class VueBricodesService {
  constructor({ appId, apiUrl, storageUrl }) {
    this.appId = appId;
    this.storageUrl = storageUrl;
    this.axios = axios.create({
      baseURL: apiUrl,
    });
  }

  async getDictionary(languageCode) {
    return axios.get(`dictionaries/${languageCode}.json`);
  }

  async getPublicEntries() {
    return this.axios.request({
      method: 'get',
      url: '/entries/public',
      params: {
        contestId: this.appId,
      },
    });
  }

  async createEntry({
    childFirstName,
    childLastName,
    firstName,
    lastName,
    email,
    phone,
    legal1 = false,
    legal2 = false,
    legal3 = false,
    legal4 = false,
    legal5 = false,
    answer,
    score,
    attachment,
  }) {
    return this.axios.request({
      method: 'post',
      url: '/entries/rodo',
      data: {
        firstName,
        lastName,
        childFirstName,
        childLastName,
        email,
        phone,
        street: NO_DATA,
        city: NO_DATA,
        zip: NO_DATA,

        contestId: this.appId,
        fingerprint: await VueBricodesService.getFingerprint(),

        result: {
          answer,
          score,
          attachment,
        },

        legals: [legal1, legal2, legal3, legal4, legal5],
      },
    });
  }

  static getFingerprint() {
    return new Promise((resolve) => {
      Fingerprint2.getV18(resolve);
    });
  }

  uploadFile(file, onUploadProgress = () => {}) {
    const formData = getFileFormData(file);

    return axios.post(this.storageUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    }).then(({ data: fileName }) => `${this.storageUrl}/${fileName}`);
  }

  static install(Vue) {
    Vue.mixin({
      beforeCreate() {
        const options = this.$options;

        if (options.bricodes) {
          this.$bricodes = options.bricodes;

          return;
        }

        if (options.parent && options.parent.$bricodes) {
          this.$bricodes = options.parent.$bricodes;
        }
      },
    });
  }
}
